




































import { defineComponent, inject, computed } from '@vue/composition-api'

// Store
import { StoreKey } from '@/store/Input'
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as ErrorStoreKey } from '@/store/Error'

export default defineComponent({
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const store = inject(StoreKey)
        if (!store) {
            throw new Error(`${StoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const input1FieldClass = computed(() => {
            return {
                'm-invalid': errorStore.request_model1.value !== null,
            }
        })
        const input2FieldClass = computed(() => {
            return {
                'm-invalid': errorStore.request_model2.value !== null,
            }
        })
        const input3FieldClass = computed(() => {
            return {
                'm-invalid': errorStore.request_model3.value !== null,
            }
        })

        return {
            formStore,
            store,
            errorStore,
            input1FieldClass,
            input2FieldClass,
            input3FieldClass,
        }
    },
})
